import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Retry',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-miterlimit": "10", d: "M12 6c3.8 0 7 3.2 7 7s-3.2 7-7 7-7-3.1-7-7" }
      }), h("path", {
        attrs: { fill: "currentColor", d: "M6.2 6.3l5.3 3.7c.2.1.5 0 .5-.3V2.3c0-.3-.3-.4-.5-.3L6.2 5.7c-.2.1-.2.4 0 .6z" }
      })]
    );
  }
};